import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { makeStyles } from '@material-ui/core/styles';

export type ILabelAndPriceClasses = 'boldLabel' | 'lineContainer' | 'price' | 'priceContainer' | 'listText';

const labelAndPriceStyles = makeStyles<ISpcTheme, ILabelAndPriceClasses>(
  theme => ({
    boldLabel: {
      fontWeight: 'bold',
    },
    lineContainer: {
      marginTop: 0,
      marginBottom: 0,
    },
    price: {
      fontSize: theme.typography.fontMD,
    },
    priceContainer: {
      textAlign: 'end',
    },
    listText: {
      fontSize: theme.typography.fontSM,
    },
  }),
  { name: 'Customise_LabelAndPrice' },
);

export default labelAndPriceStyles;
